/* global Uint8Array */


/**
 * Generates a SHA-256 hash of a string using the Web Crypto API.
 *
 * Returns undefined if the input is invalid, hashing is unsupported, or
 * hashing fails.
 *
 * @async
 * @param {string} data - The string to hash.
 * @returns {Promise<string | undefined>} A Promise that resolves to the
 * SHA-256 hash as a 64-character hexadecimal string, or undefined if the
 * input is invalid or hashing is unsupported or fails.
 */
export async function getHashedData(data) {
	if (typeof data !== 'string' || data?.trim()?.length === 0) {
		return undefined;
	}

	const isCryptoSupported = typeof crypto !== 'undefined' && !!crypto.subtle && typeof TextEncoder !== 'undefined' && typeof Uint8Array !== 'undefined';

	if (!isCryptoSupported) {
		return undefined;
	}

	try {
		const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(data));
		return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');
	} catch {
		return undefined;
	}
}
